import axios from "axios";
 let token = ""//(window.userName !== 'null' || window.userName !== null) && window.accountToken
// const baseURL = window.location.origin //'https://apisit.mobily.com.sa/api'
const cem_key = 'liCENcCCGpHUsEPHNhySYGXCnmhwzZ';
// const lang = window.lang;

let config = {
    api: {
      baseURL: '',
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "",
        TransactionId: new Date().getTime(),
        channel: "PORTAL",
        "cem-key": cem_key,
        lang: '',
      },
    },
  };
  
  export const api = axios.create({ ...config.api });

  
api.interceptors.request.use(
    async (conf:any) => {
      console.log("token : " + token);
      conf.headers.Authorization = "Bearer " + token;
      return conf;
    },
    (err:any) => {
      console.log("error in getting ", err);
    }
  );

  
const createTransactionID = () => {
  let currentDateTime = new Date().toISOString().replace(/-|:|T/gi, '').slice(0, 8);
  return 'POR' + currentDateTime + '' + Math.ceil(Math.random() * 100000);
}


const apiBaseUrl = (() => {
  // Define the URLs based on your conditions
  const defaultUrl = 'https://mobily.com.sa';
  const devUrl = 'https://apidev.mobily.com.sa';
  const sitUrl = 'https://apisit.mobily.com.sa';
  const preProdUrl = 'https://apipreprod.mobily.com.sa';


  // Check the condition and decide which URL to use
  if (window.location.origin.includes('http://sdea004:8080')) {
    return devUrl;
  } else if (window.location.origin.includes('http://ssta004:8080')) {
    return sitUrl;
  }else if (window.location.origin.includes('http://sppa012:8080')) {
    return preProdUrl;
  }else if (window.location.origin.includes('http://localhost:3000')) {
    return sitUrl;
  }
  return defaultUrl;
})();




  //thumbsUpApi
export async function submitThumbsUpApi(btnDownClicked:any, userComments:any, selectedServiceId:any) {
   
    var requestBody = {
        APP_ID: "Portal",
        AREAS: "FAQs",
        COMMENTS: userComments,
        DEVICE_ID: "",
        FEEDBACK_ID: "2",
        FEEDBACK_SCORE: btnDownClicked ? "3" : "5",
        LANG: "EN",
        MSISDN: "",
        SESSION_ID: "",
        TRANSACTION_ID: createTransactionID(),
        USER_NAME: "",
        VERSION: "2.0",
        FEEDBACK_SERVICES: [
          {
            SERVICE_ID: selectedServiceId
          }
        ]
    }
  
    return axios({
      method: "post",
      url: `${apiBaseUrl}/mobilybe/rest/oth/consumer/app/feedback`,
      data: requestBody,
      headers: {
        "Content-Type": "application/json",
        "User_id":"",
        "cem-key": cem_key,
        "Authorization": "Bearer" + " " + token
      }
    }).then((res) => {
      console.log("Response from API:", res.data);
      return res.data; // Return response data
    });
  };


  
  //thumbDownApi
export async function submitThumbsDwonApi() {
   
    var requestBody = {
        TRANSACTION_ID: createTransactionID(),
        SESSION_ID: "",
        VERSION: "2.0",
        APP_ID: "Portal",
        DEVICE_ID: "",
        USER_NAME: "",
        LANG: "EN"
    }
  
    return axios({
      method: "post",
      url: `${apiBaseUrl}/mobilybe/rest/oth/consumer/app/feedbackServiceInq`,
      data: requestBody,
      headers: {
        "Content-Type": "application/json",
        "User_id":"",
        "cem-key": cem_key,
        "Authorization": "Bearer" + " " + token
      }
    }).then((res) => {
      console.log("Response from API:", res.data);
      return res.data; // Return response data
    });
  };